// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'archive';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M15.906 7.406v6.73a2.125 2.125 0 0 1-2.125 2.124H4.22a2.125 2.125 0 0 1-2.125-2.125V7.406M15.906 1.74H2.094A1.063 1.063 0 0 0 1.03 2.802v2.125h15.94V2.802a1.063 1.063 0 0 0-1.063-1.062z' />
    <path d='M7.583 7.76h2.834s1.062 0 1.062 1.063v.708s0 1.063-1.062 1.063H7.583s-1.062 0-1.062-1.063v-.708s0-1.063 1.062-1.063z' />
  </g>
);

export const viewBox = '0 0 18 18';
